<template>

    <section class="symptoms" id="symptoms">
        <div class="container">
            <div class="grid">
                <div class="text">
                    <h1>Jakie są objawy SCAD?</h1>
                    <p>
                        Ból w klatce piersiowej, zlokalizowany za mostkiem, gniotący – może promieniować do lewego
                        barku, czasami do nadbrzusza, żuchwy, niekiedy jest to pieczenie zlokalizowane za mostkiem,
                        uczucie ciężaru, duszność. Mogą mu towarzyszyć: nudności, wymioty.


                    </p>
                    <h4>W razie pojawienia się takich objawów należy natychmiast wezwać pogotowie ratunkowe. </h4>

                </div>
                <div class="pain-animation-wrapper">
                    <span class="pain-animation" id="pain-animation" />
                </div>



            </div>
        </div>
    </section>

</template>

<script>
    // import { /*TimelineMax,*/ TweenMax } from 'gsap'

    export default {

        mounted() {
            //   // Declare Scene
            //   const timeline = new TimelineMax()
            //     timeline.add(TweenMax.to('#strikethrough', 2, { 
            //         width: '100%',
            //         visibility:'visible'
            //     }))
            //     timeline.add(TweenMax.to('#slide-up', 2, { 
            //         bottom:0,
            //         opacity:1,
            //         visibility:'visible'
            //     }))
            //     const toggleTitleScene = this.$scrollmagic.scene({
            //     triggerElement: '#about-scad',
            //     // {0,0.5,1} - animations starts from {top,center,end} of window
            //     triggerHook: 1,
            //     duration: 500
            //   }).setTween(timeline)

            const showPainAnimationScene = this.$scrollmagic.scene({
                triggerElement: '#symptoms',
                // {0,0.5,1} - animations starts from {top,center,end} of window
                triggerHook: .6,
                duration: 300
            }).setTween('#pain-animation', .5, {
                css: {
                    visibility: 'visible',
                    opacity: 1,
                    className: '+=active'
                }
            })

            // Helpful tags for orientation on the screen
            // .addIndicators({ name: '2 (duration: 300)' })

            // Add Scene to controller
            this.$scrollmagic.addScene(showPainAnimationScene)

        }
    }
</script>

<style lang="scss" scoped>
@import '../../vars.scss';
    .symptoms {

        margin-top: 10vh;

        .grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-areas: "text animation";

        @media(max-width: 580px){
            grid-template-columns: 1fr;
            grid-template-areas: "animation"
                                 "text";
        }
        }
        .text{
            grid-area: text;
        }
        .pain-animation-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            grid-area: animation;

            .pain-animation {
                   
                display: block;
                position: relative;
                width: 20vh;
                height: 20vh;
                visibility: hidden;
                opacity: 0;
                background: rgba(238, 89, 84, .7);
                border-radius: 50%;

                &.active,
                &.active::after {
                    opacity: 1;
                    visibility: visible;
                    transform: scale(0);
                }

                &.active {
                    animation: pain-animation 5s 0s infinite forwards;
                }

                &.active::after {
                    animation: pain-animation 5s .5s infinite forwards;
                }

                &::after {
                    content: '';
                    top: 0;
                    left: 0;
                    position: absolute;
                    display: block;
                    width: inherit;
                    height: inherit;

                    // background:rgba(238, 89, 84, .7);
                    background: $primary;
                    border-radius: 50%;
                }
            }
        }

        h2 {
            color: rgba(0, 0, 0, 0.5);

            span {
                color: black;
            }
        }

        p {
            line-height: 1.5em;
            font-size: 1.2em;
            color: rgba(0, 0, 0, 0.7);
        }

    }

    @keyframes pain-animation {
        0% {
            transform: scale(0.2);
        }

        50% {
            transform: scale(1);
        }

        100% {
            transform: scale(0.2);
        }
    }
</style>
